// material-ui
import { withStyles } from "@material-ui/styles";
// custom
import Table from "components/Table";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import TableEdit from "../TableEdit";
// styles
import styles from "./styles";

class InstrumentFamiliesList extends PureComponent {
  static propTypes = {
    // classes: PropTypes.object,
    instrumentFamilies: PropTypes.array,
    onSelect: PropTypes.func,
  };

  onSelect(selectedInstrumentFamilie) {
    const { onSelect } = this.props;
    if (onSelect) {
      onSelect(selectedInstrumentFamilie);
    }
  }

  render() {
    const { instrumentFamilies } = this.props;

    return (
      <Table
        data={instrumentFamilies}
        meta={[
          {
            path: "id",
            title: "ID",
            width: 30,
          },
          {
            path: "name",
            title: "Name",
            numeric: false,
          },
          {
            path: "id",
            numeric: false,
            component: TableEdit,
            inject: {
              onEdit: this.onSelect.bind(this),
            },
            width: 30,
          },
        ]}
        title={"Instrument Families"}
        onRowSelect={() => console.log("Clicked")}
      />
    );
  }
}

export default withStyles(styles)(InstrumentFamiliesList);
